;(function () {
  const initProductAccordion = () => {
    $(".about__accordion-toggle").click(function () {
      if (!$(this).hasClass("active")) {
        $(this).addClass("active");
        $(this)
          .siblings(".about__accordion-description")
          .eq($(this).index())
          .stop()
          .slideDown(300);
      } else {
        $(this).removeClass("active");
        $(this).siblings(".about__accordion-description").stop().slideUp(300);
      }
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector(
      ".product-media-modal__content"
    );
    const images = imagesWrapper?.querySelectorAll(".js-image-zoom");

    images?.forEach((el) => {
      el.addEventListener("click", (e) => {
        imagesWrapper.classList.toggle("zoom");
      });
    });
  };

  document.addEventListener("shopify:section:load", () => {
    initProductAccordion();
    initZoomImage();
  });
  initProductAccordion();
  initZoomImage();
})();

// ----------------- Fabric Logic -----------------
class FabricCalculator {
  constructor() {
    this.init();
  }

  init() {
    const el = document.querySelector("#fabric-total-price");
    if (!el || !el.dataset.vatPct) return;
    
    // ADDED: Store variant data for calculations
    this.storeVariantData();
    
    this.updateMaxFromInventory();
    this.setupEventListeners();
    this.updatePrice();
    this.updateLength();
  }

  // ADDED: Store all variant data for dynamic calculations
  storeVariantData() {
    this.variants = [];
    
    // Try to get variant data from window object first
    if (window.productVariants) {
      this.variants = window.productVariants;
      console.log('Loaded variants from window:', this.variants.length);
      return;
    }
    
    // Fallback: extract from DOM elements
    console.log('Fallback: extracting variants from DOM');
    const variantInputs = document.querySelectorAll('input[data-variant-id]');
    const uniqueVariants = new Set();
    
    variantInputs.forEach(input => {
      const variantId = input.dataset.variantId;
      if (!uniqueVariants.has(variantId)) {
        uniqueVariants.add(variantId);
        
        const variantInfo = {
          id: variantId,
          option1: input.dataset.option1 || input.getAttribute('data-option1'),
          option2: input.dataset.option2 || input.getAttribute('data-option2'),
          inventory_quantity: parseInt(input.dataset.inventory || input.getAttribute('data-inventory'), 10) || 0,
          title: input.dataset.title || input.getAttribute('data-title') || ''
        };
        
        this.variants.push(variantInfo);
      }
    });
    
    console.log('Extracted variants from DOM:', this.variants.length);
  }

  // ADDED: Get currently selected variant
  getSelectedVariant() {
    const selectedInput = document.querySelector('input[data-variant-id]:checked');
    if (selectedInput) {
      const variantId = selectedInput.dataset.variantId;
      return this.variants.find(v => v.id == variantId);
    }
    return null;
  }

  updateInlineInventory() {
    const mainInv = document.querySelector('.product__inventory:not([id*="-inline"])');
    const inlineInvs = document.querySelectorAll('[id*="-inline"].product__inventory');
    
    console.log('Found elements:', { mainInv, inlineCount: inlineInvs.length });
    
    if (mainInv && inlineInvs.length > 0) {
      inlineInvs.forEach(inlineInv => {
        inlineInv.innerHTML = mainInv.innerHTML;
      });
      console.log('✅ Updated all inline inventories');
    } else {
      console.log('❌ Elements not found');
    }
  }

  updatePrice() {
    const el = document.querySelector("#fabric-total-price");
    const qtyInput = document.querySelector(".quantity__input");
    let qty = parseInt(qtyInput?.value, 10) || 1;
    const min = parseInt(qtyInput?.getAttribute("min"), 10) || 1;
    const max = parseInt(qtyInput?.getAttribute("max"), 10) || null;
    if (qty < min) qty = min;
    if (max && qty > max) qty = max;
    if (qtyInput) qtyInput.value = qty;

    const net = parseFloat(el.dataset.netPrice) || 0;
    // IVA di display da snippets/vat-rate.liquid: B2B (vatIncl "0") → netto + "+ IVA", gli altri lordo
    const incl = el.dataset.vatIncl !== "0";
    const vat = incl ? parseFloat(el.dataset.vatPct) || 0 : 0;
    const exLabel = el.dataset.vatExLabel || "IVA esclusa";
    const disc = parseFloat(el.dataset.discountPct) || 0;
    const label = el.dataset.vatLabel || "IVA:";

    // scontato come al checkout: sconto per unita' arrotondato per difetto (assets/global.js)
    const unitCents = Math.round(net * 100);
    const totOrig = (unitCents * qty * (1 + vat / 100)) / 100;
    const totDisc = (window.zwCheckoutCents(unitCents, disc) * qty * (1 + vat / 100)) / 100;
    const vatDisc = totDisc - totDisc / (1 + vat / 100);

    const fmt = (n) =>
      "€" +
      n.toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    const totalLabel = (el.dataset.totalLabel || 'Totale').trim();
    const orderedEl = document.querySelector('#fabric-ordered-length');
    if (orderedEl) {
      const perRoll = parseFloat(orderedEl.dataset.meters) || 1;
      orderedEl.textContent = (perRoll * qty).toFixed(2);
    }
    
    if (disc > 0) {
      el.innerHTML = `
        <strong>${totalLabel}:</strong>
        <s>${fmt(totOrig)}</s>
        <span style="color:#e32c2b;font-weight:700;">${fmt(totDisc)}</span><br>
        <small>(${incl && vat > 0 ? `${label} ${fmt(vatDisc)}` : exLabel})</small>
      `;
    } else {
      const vatReg = totOrig - totOrig / (1 + vat / 100);
      el.innerHTML = `
        <strong>${totalLabel}:</strong>
        ${fmt(totOrig)}<br>
        <small>(${incl && vat > 0 ? `${label} ${fmt(vatReg)}` : exLabel})</small>
      `;
    }
  }

  updateLength() {
    const lengthEl = document.querySelector("#fabric-length");
    if (!lengthEl) return;

    // Get currently selected color
    const selectedColor = this.getSelectedColor();
    console.log('Selected color:', selectedColor);
    
    if (!selectedColor || !this.variants || this.variants.length === 0) {
      // Fallback to original behavior if we can't get color or variants
      const precomputed = parseFloat(lengthEl?.dataset?.total);
      if (!isNaN(precomputed)) {
        lengthEl.textContent = precomputed.toFixed(2);
        console.log('Using precomputed value:', precomputed);
        return;
      }
    }

    // Calculate total fabric length for selected color dynamically
    let totalFabricLength = 0;
    const exclusionTerms = window.fabricExclusions || ['campione', 'sample'];
    
    console.log('Calculating total for color:', selectedColor);
    console.log('Available variants:', this.variants.length);
    
    // Calculate from variant data (like server-side Liquid does)
    this.variants.forEach(variant => {
      if (variant.option1 === selectedColor && variant.inventory_quantity > 0) {
        // Check if variant should be excluded
        const shouldExclude = exclusionTerms.some(term => 
          variant.title && variant.title.toLowerCase().includes(term.toLowerCase())
        );
        
        if (!shouldExclude && variant.option2) {
          const rollLength = parseFloat(variant.option2.replace(/[^\d.,]/g, '').replace(',', '.'));
          if (!isNaN(rollLength)) {
            const variantTotalLength = rollLength * variant.inventory_quantity;
            totalFabricLength += variantTotalLength;
            console.log(`Variant ${variant.id}: ${rollLength}m × ${variant.inventory_quantity} = ${variantTotalLength}m`);
          }
        }
      }
    });
    
    // Update the display
    const formattedLength = Math.round(totalFabricLength * 100) / 100;
    lengthEl.textContent = formattedLength.toFixed(2);
    console.log('Updated total fabric length to:', formattedLength);
  }

  // Get currently selected color
  getSelectedColor() {
    // Try to get from selected variant first
    const selectedVariant = this.getSelectedVariant();
    if (selectedVariant) {
      return selectedVariant.option1;
    }
    
    // Fallback: try to get from color selector
    const colorInput = document.querySelector('input[name*="option1"]:checked, input[name*="Color"]:checked, input[name*="Colore"]:checked');
    return colorInput ? colorInput.value : null;
  }

  setupEventListeners() {
    ["click", "input", "blur", "change"].forEach((evt) => {
      document.querySelectorAll("button.quantity__button").forEach((btn) =>
        btn.addEventListener("click", () => {
          this.updatePrice();
          this.updateLength();
        })
      );
      const input = document.querySelector(".quantity__input");
      if (input) input.addEventListener(evt, () => {
        this.updatePrice();
        this.updateLength();
      });
    });

    // React to changes in the roll length radio group
    document
      .querySelectorAll('.product-variant-box input[type="radio"], input[type="radio"][name*="Misura"][name*="Rotolo"]')
      .forEach((r) => r.addEventListener("change", () => this.updateLength()));

    // ADDED: Listen for color/option changes - THIS IS THE KEY FIX!
    document.querySelectorAll('input[name*="option1"], input[name*="Color"], input[name*="Colore"]')
      .forEach((r) => r.addEventListener("change", () => {
        setTimeout(() => {
          console.log('Color changed, updating length...');
          this.updateLength();
        }, 100);
      }));

    document
      .querySelectorAll('input[type="radio"][data-variant-id]')
      .forEach((r) =>
        r.addEventListener("change", () => {
          const input = document.querySelector(".quantity__input");
          if (input) input.value = 1;
          setTimeout(() => {
            this.updateMaxFromInventory();
            this.updatePrice();
            this.updateLength(); // This will now work properly
            this.updateInlineInventory();
          }, 800);
        })
      );
  }

  updateMaxFromInventory() {
    const qtyInput = document.querySelector(".quantity__input");
    const invEl = document.querySelector(".product__inventory .inv-qty");
    if (!qtyInput || !invEl) return;
    const inv = parseInt(invEl.textContent.trim(), 10);
    if (!isNaN(inv) && inv > 0) {
      qtyInput.setAttribute("max", String(inv));
      qtyInput.setAttribute("data-max", String(inv));
      if (parseInt(qtyInput.value, 10) > inv) qtyInput.value = String(inv);
    }
  }
}

// ----------------- Leather Logic (unchanged) -----------------
class LeatherCalculator {
  constructor() {
    this.init();
  }

  init() {
    const el = document.querySelector("#leather-total-price");
    if (!el || !el.dataset.hideSize) return;
    this.setupEventListeners();
    this.updatePrice();
    this.updateLeatherArea();
  }

  updateInlineInventory() {
    const mainInv = document.querySelector(".product__inventory");
    const inlineInv = document.querySelector('[id$="-inline"].product__inventory');
    
    if (mainInv && inlineInv) {
      inlineInv.innerHTML = mainInv.innerHTML;
    }
  }

  updatePrice() {
    const el = document.querySelector("#leather-total-price");
    const qty = Math.max(
      1,
      parseInt(document.querySelector(".quantity__input").value, 10) || 1
    );

    const net = parseFloat(el.dataset.netPrice) || 0;
    // IVA di display da snippets/vat-rate.liquid: B2B (vatIncl "0") → netto + "+ IVA", gli altri lordo
    const incl = el.dataset.vatIncl !== "0";
    const vat = incl ? parseFloat(el.dataset.vatPct) || 0 : 0;
    const exLabel = el.dataset.vatExLabel || "IVA esclusa";
    const disc = parseFloat(el.dataset.discountPct) || 0;
    const hide = parseFloat(el.dataset.hideSize) || 1;
    const label = el.dataset.vatLabel || "IVA:";

    // scontato come al checkout: sconto per unita' arrotondato per difetto (assets/global.js)
    const unitCents = Math.round(net * 100);
    const totOrig = (unitCents * qty * (1 + vat / 100)) / 100;
    const totDisc = (window.zwCheckoutCents(unitCents, disc) * qty * (1 + vat / 100)) / 100;
    const vatDisc = totDisc - totDisc / (1 + vat / 100);

    const fmt = (n) =>
      "€" +
      n.toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    if (disc > 0) {
      el.innerHTML = `
        <strong>Totale:</strong>
        <s>${fmt(totOrig)}</s>
        <span style="color:#e32c2b;font-weight:700;">${fmt(totDisc)}</span><br>
        <small>(${incl && vat > 0 ? `${label} ${fmt(vatDisc)}` : exLabel})</small>
      `;
    } else {
      const vatReg = totOrig - totOrig / (1 + vat / 100);
      el.innerHTML = `
        <strong>Totale:</strong>
        ${fmt(totOrig)}<br>
        <small>(${incl && vat > 0 ? `${label} ${fmt(vatReg)}` : exLabel})</small>
      `;
    }
  }

  updateLeatherArea() {
    const qty = parseInt(document.querySelector(".quantity__input").value, 10) || 1;
    const areaEl = document.querySelector("#leather-area");
    const base = parseFloat(areaEl.dataset.hideSize) || 1;
    areaEl.textContent = (base * qty).toFixed(2);
  }

  setupEventListeners() {
    ["click", "input", "blur", "change"].forEach((evt) => {
      document.querySelectorAll("button.quantity__button").forEach((btn) =>
        btn.addEventListener("click", () => this.updatePrice())
      );
      const input = document.querySelector(".quantity__input");
      if (input) input.addEventListener(evt, () => this.updatePrice());
    });
    document.querySelectorAll('input[type="radio"][data-variant-id]').forEach((r) =>
      r.addEventListener("change", () => {
        document.querySelector(".quantity__input").value = 1;
        setTimeout(() => {
          this.updatePrice();
          this.updateLeatherArea();
        }, 800);
      })
    );
  }
}

// ------------- Initialize Based on Context -------------
const initializeCalculators = () => {
  // hide-size presente → leather; altrimenti → fabric.
  if (document.querySelector("#leather-total-price")?.dataset.hideSize) {
    new LeatherCalculator();
  } else {
    new FabricCalculator();
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeCalculators);
} else {
  initializeCalculators();
}